<template>
  <div>
    <a-card size="small" :loading="loading">
      <template slot="title">
        <span style="margin-right: 4px">研发团队交付报表</span>
        <a-popover title="报表说明" placement="topLeft">
          <template slot="content">
            <p>研发团队交付报表</p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </template>
      <a-table size="small" :pagination="false" :columns="columns" row-key="index" :data-source="team_data" :loading="loading">
        <span slot="team_name" slot-scope="text, record" @click="onClick(record.team_id)">{{ record.team_name }} </span>
        <span slot="less_than_half_per" slot-scope="text, record">
          <span v-if="record.total_num != 0">{{ ((record.less_than_half / record.total_num) * 100).toFixed(2) }}%</span>
          <span v-else>{{ '0.00%' }}</span>
        </span>
        <span slot="in_one_day_per" slot-scope="text, record">
          <span v-if="record.total_num != 0">{{ ((record.in_one_day / record.total_num) * 100).toFixed(2) }}%</span>
          <span v-else>{{ '0.00%' }}</span>
        </span>
        <span slot="more_than_one_day_per" slot-scope="text, record">
          <span v-if="record.total_num != 0">{{ ((record.more_than_one_day / record.total_num) * 100).toFixed(2) }}%</span>
          <span v-else>{{ '0.00%' }}</span>
        </span>
      </a-table>
    </a-card>
    <div v-if="taskList && taskList.length > 0">
      <task-to-qa-modal ref="taskListModal" :task-list="taskList" />
    </div>
  </div>
</template>
<script>
import { taskToQaTime } from '@/api/data/task';
import TaskToQaModal from '@/pages/data/components/TaskToQaModal';

const columns = [
  {
    title: '团队名称',
    dataIndex: 'team_name',
    key: 'team_name',
    width: '100px',
    ellipsis: true,
    scopedSlots: { customRender: 'team_name' }
  },
  {
    title: '员工平均每日吞吐量',
    dataIndex: 'employee_avg_throughput',
    key: 'employee_avg_throughput',
    width: '150px',
    // sorter: (a, b) => a.total_num - b.total_num,
    ellipsis: true
  },
  {
    title: '需求吞吐量',
    dataIndex: 'requirement_throughput',
    key: 'requirement_throughput',
    width: '100px',
    ellipsis: true
  },
  {
    title: '对比需求吞吐量',
    dataIndex: 'comparison_requirement_throughput',
    key: 'comparison_requirement_throughput',
    width: '130px',
    ellipsis: true,
    scopedSlots: { customRender: 'comparison_requirement_throughput' }
  },
  {
    title: '吞吐量变化趋势',
    dataIndex: 'throughput_variation_trend',
    key: 'throughput_variation_trend',
    width: '130px',
    ellipsis: true
  },
  {
    title: '交付周期',
    dataIndex: 'delivery_cycle',
    key: 'delivery_cycle',
    width: '100px',
    ellipsis: true
    // scopedSlots: { customRender: 'delivery_cycle' }
  },
  {
    title: '对比交付周期',
    dataIndex: 'comparison_delivery_cycle',
    key: 'comparison_delivery_cycle',
    width: '100px',
    ellipsis: true
  },
  {
    title: '交付周期变化趋势',
    dataIndex: 'delivery_cycle_variation_trend',
    key: 'delivery_cycle_variation_trend',
    width: '130px',
    ellipsis: true
  },
  {
    title: '线上缺陷数',
    dataIndex: 'bug_sum',
    key: 'bug_sum',
    width: '100px',
    ellipsis: true
  },
  {
    title: '未上线需求数量',
    dataIndex: 'not_online_requirement_sum',
    key: 'not_online_requirement_sum',
    width: '130px',
    ellipsis: true
  },
  {
    title: '未上线需求已等待时长',
    dataIndex: 'not_online_requirement_sleep_time',
    key: 'not_online_requirement_sleep_time',
    width: '150px',
    ellipsis: true
  },
  {
    title: '请假',
    dataIndex: 'ask_for_leave_day',
    key: 'ask_for_leave',
    width: '100px',
    ellipsis: true
  },
  {
    title: '加班',
    dataIndex: 'overtime',
    key: 'overtime',
    width: '100px',
    ellipsis: true
  },
  {
    title: '非工作日',
    dataIndex: 'standby_unattended_day',
    key: 'standby_unattended_day',
    width: '100px',
    ellipsis: true
  },
  {
    title: '总天数',
    dataIndex: 'day_sum',
    key: 'day_sum',
    width: '100px',
    ellipsis: true
  },
  {
    title: '团队规模',
    dataIndex: 'team_size',
    key: 'team_size',
    width: '100px',
    ellipsis: true
  }
];
export default {
  components: { TaskToQaModal },
  props: {
    sourceId: {
      type: [String, Number],
      default: null
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      columns,
      loading: false,
      visible: false,
      activeKey: '1',
      taskData: {},
      taskList: [],
      data: {
        title: null,
        projects: [],
        start_date: null,
        end_date: null,
        description: null,
        params: {}
      },
      formData: {},
      team_data: [],
      correctionData: []
    };
  },
  watch: {
    filterForm() {
      this.getDiagramData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },

  methods: {
    onClick(team_id) {
      this.taskList = this.taskData[team_id];
      // this.index = index;
      setTimeout(() => {
        this.$refs.taskListModal.open();
      }, 10); // 延迟 200 毫秒
    },
    getDiagramData() {
      this.loading = true;
      taskToQaTime({ ...this.filterForm })
        .then(res => {
          this.team_data = res.data.items || [];
          this.taskData = res.data.results;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .ant-table-tbody > tr > td > p {
  padding: 8px;
  border-bottom: 1px solid #e8e8e8;
  line-height: 20px;
  margin: 0 -8px;
}

/deep/ .ant-table-tbody > tr > td > p:last-child {
  margin-bottom: -12px;
  border: 0;
}

/deep/ .ant-table-tbody > tr > td > p:first-child {
  margin-top: -8px;
}
/deep/.ant-page-header {
  padding: 0;
}

/deep/.ant-tabs-bar {
  margin: 0 0 12px 0;
}
</style>
